export default __webpack_public_path__ + "static/media/download.7a952fdb.png";